/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export var GroupEnum = /*#__PURE__*/function (GroupEnum) {
  GroupEnum["DEFAULT"] = "DEFAULT";
  GroupEnum["SELECT_ALL"] = "SELECT_ALL";
  return GroupEnum;
}({});
export var LiveSessionOrderByEnum = /*#__PURE__*/function (LiveSessionOrderByEnum) {
  LiveSessionOrderByEnum["CREATED_AT"] = "CREATED_AT";
  LiveSessionOrderByEnum["END_DATE"] = "END_DATE";
  LiveSessionOrderByEnum["ID"] = "ID";
  LiveSessionOrderByEnum["START_DATE"] = "START_DATE";
  return LiveSessionOrderByEnum;
}({});
export var OrderDirectionEnum = /*#__PURE__*/function (OrderDirectionEnum) {
  OrderDirectionEnum["ASC"] = "ASC";
  OrderDirectionEnum["DESC"] = "DESC";
  return OrderDirectionEnum;
}({});

/**
 * The `ReportState` enum represents the different states that a report can have throughout its lifecycle.
 */
export var SessionReportStateEnum = /*#__PURE__*/function (SessionReportStateEnum) {
  SessionReportStateEnum["FAILED"] = "FAILED";
  SessionReportStateEnum["FINISHED"] = "FINISHED";
  SessionReportStateEnum["INITIAL"] = "INITIAL";
  SessionReportStateEnum["PROCESSING"] = "PROCESSING";
  return SessionReportStateEnum;
}({});
export var SessionTimeLineEnum = /*#__PURE__*/function (SessionTimeLineEnum) {
  SessionTimeLineEnum["FOR_START"] = "FOR_START";
  SessionTimeLineEnum["FUTURE"] = "FUTURE";
  SessionTimeLineEnum["LIVE"] = "LIVE";
  SessionTimeLineEnum["PAST"] = "PAST";
  return SessionTimeLineEnum;
}({});
export var SessionTimeZoneEnum = /*#__PURE__*/function (SessionTimeZoneEnum) {
  SessionTimeZoneEnum["TIME_ZONE_ES_AR"] = "TIME_ZONE_ES_AR";
  SessionTimeZoneEnum["TIME_ZONE_ES_CL"] = "TIME_ZONE_ES_CL";
  SessionTimeZoneEnum["TIME_ZONE_ES_CO"] = "TIME_ZONE_ES_CO";
  SessionTimeZoneEnum["TIME_ZONE_ES_ES"] = "TIME_ZONE_ES_ES";
  SessionTimeZoneEnum["TIME_ZONE_ES_MX"] = "TIME_ZONE_ES_MX";
  SessionTimeZoneEnum["TIME_ZONE_ES_PE"] = "TIME_ZONE_ES_PE";
  SessionTimeZoneEnum["TIME_ZONE_PT_BR"] = "TIME_ZONE_PT_BR";
  return SessionTimeZoneEnum;
}({});
export var SessionTypeEnum = /*#__PURE__*/function (SessionTypeEnum) {
  SessionTypeEnum["ONLINE"] = "ONLINE";
  SessionTypeEnum["PRESENCE"] = "PRESENCE";
  return SessionTypeEnum;
}({});

/**
 * Used to filter queries
 */
export var StatusSessionEnum = /*#__PURE__*/function (StatusSessionEnum) {
  StatusSessionEnum["NEXT"] = "NEXT";
  StatusSessionEnum["PAST"] = "PAST";
  return StatusSessionEnum;
}({});
export var UserStatusEnum = /*#__PURE__*/function (UserStatusEnum) {
  UserStatusEnum["CONFIRMED"] = "CONFIRMED";
  UserStatusEnum["NO_CONFIRMED"] = "NO_CONFIRMED";
  UserStatusEnum["REJECTED"] = "REJECTED";
  return UserStatusEnum;
}({});
export var UserStatusOrderByEnum = /*#__PURE__*/function (UserStatusOrderByEnum) {
  UserStatusOrderByEnum["CREATED_AT"] = "CREATED_AT";
  UserStatusOrderByEnum["ID"] = "ID";
  UserStatusOrderByEnum["STATUS"] = "STATUS";
  return UserStatusOrderByEnum;
}({});

/**
 * Input used in mutation to add users to an existing session [Mutation]
 */

/**
 * Input for list a live sessions, NO PAGINATED [Query]
 */

/**
 * Input for list LiveSessionUserSession WITHOUT PAGINATION [Query]
 */

/**
 * Input for delete a live session [Mutation]
 */

/**
 * Input for retrieve a live session [Query]
 */

/**
 * Input for create a live session [Mutation]
 */

/**
 * Input for creating a live session report [Mutation]
 */

/**
 * Input for delete a live session resource [Mutation]
 */

/**
 * Input for create a live session resources [Mutation]
 */

/**
 * Input for update a live session [Mutation]
 */

/**
 * Input for delete a live session users [Mutation]
 */

/**
 * Input for list LiveSessionUserSession Participant [Query]
 */

/**
 * Input for represent a live session External resource [Mutation]
 */

/**
 * Input for update a live session users status [Mutation]
 */

/**
 * This input is used in queries or mutation, represent basic user fields [Queries or Mutation]
 */

//==============================================================
// END Enums and Input Objects
//==============================================================